function f(n) {
  return {
    response: i,
    setup: r
  };
  function r(o) {
    if (n.endpoint.hasParams() && !o)
      throw new Error(
        `You must pass settings in setup() for endpoint ${n.endpoint.getTemplateUrl()}`
      );
    return d({
      ...n,
      // use "as Settings" here because we checked invalid settings above
      settings: o ?? (() => ({}))
    });
  }
  function i() {
    return f(n);
  }
}
function d(n) {
  let r = new AbortController();
  return {
    abort: o,
    request: u,
    // @ts-expect-error ts don't like function overloading in RequesterEntity
    requestCustom: a
  };
  function i() {
    return r.signal.aborted && (r = new AbortController()), r.signal;
  }
  function o() {
    r.abort();
  }
  async function u(...t) {
    return a({}, ...t);
  }
  async function a(t, ...p) {
    let e = n.settings(...p);
    if ((!t.dedupe || t.dedupe === "abort") && o(), "config" in e) {
      const s = { ...e.config, ...e };
      delete s.config, console.warn(
        `Passing "config" option to request is deprecated. Please, unwrap "config" object.
Before:
${JSON.stringify(e, null, 2)}
After:
${JSON.stringify(s, null, 2)}`
      ), e = s;
    }
    const c = n.endpoint.url(e.params), l = await n.requester.request(c, {
      ...e,
      // @ts-expect-error ts blame for function overloading
      response: t.response,
      method: n.endpoint.method,
      retry: e.retry ?? t.retry,
      signal: t.signal ?? i()
    });
    return e.modifyResponse ? e.modifyResponse(l) : l;
  }
}
export {
  f as c
};
//# sourceMappingURL=requesterEntity.js.map
